import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css";
import "./App.css";
import "./assets/css/style.css";
import ScrollToTop from "./ScrollToTop";


ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter basename="/">
    <ScrollToTop />
    <App />
  </BrowserRouter>
);